import router from '@/router/index.js'
import _ from 'lodash'

const initialQueryItems = {
    pageIndex: 1,
    keyword: '',
    locationN: [],
    locationM: [],
    locationS: [],
    locationE: [],
    locationO: [],
    minParticipateNum: 0,
    maxParticipateNum: 200,
    startDate: '',
    endDate: '',
    orderType: '',
    unitPublishNumber: '',
    productName: '',
}

export function initQueryItems(
    queryItems,
    routeQuery = router.currentRoute.value.query
) {
    Object.keys(queryItems).forEach((key) => {
        queryItems[key] = _.cloneDeep(initialQueryItems[key])
    })
    for (let key of Object.keys(routeQuery)) {
        if (queryItems[key] === undefined) continue
        if (Array.isArray(queryItems[key])) {
            queryItems[key] = routeQuery[key].split('|')
        } else if (typeof queryItems[key] === 'number') {
            queryItems[key] = routeQuery[key] * 1
        } else {
            queryItems[key] = routeQuery[key]
        }
    }
}
export function updateRoute(key, value) {
    if (!key) {
        router.push({ path: router.currentRoute.value.path })
        return
    }
    let newQuery = _.cloneDeep(router.currentRoute.value.query)
    function updateQuery(subKey, subValue) {
        if (!subValue) {
            delete newQuery[subKey]
        } else if (Array.isArray(subValue)) {
            if (subValue.length) newQuery[subKey] = subValue.join('|')
            else delete newQuery[subKey]
        } else {
            newQuery[subKey] = subValue
        }
    }
    if (Array.isArray(key)) {
        for (let i = 0; i < key.length; i++) {
            if (value) updateQuery(key[i], value[i])
            else updateQuery(key[i])
        }
    } else {
        updateQuery(key, value)
    }
    if (key !== 'pageIndex') delete newQuery['pageIndex']

    router.push({
        path: router.currentRoute.value.path,
        query: newQuery,
    })
}
